import { resolvePromises } from "../../utils/promise";

const requestMicrophonePermissions = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach((track) => track.stop());
  } catch (err) {
    console.error(err);
  }
};

const getAllMicsID = async () => {
  const devices = await navigator.mediaDevices.enumerateDevices();
  return devices
    .filter(({ kind }) => kind === "audioinput")
    .map((device) => device.deviceId);
};

const getMicrophoneData = async (deviceId) => {
  if (!deviceId) return;

  // Get the video streams
  let stream;
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      audio: { deviceId: { exact: deviceId } },
    });
  } catch (err) {
    console.error(err);
    return;
  }
  if (!stream) return;

  const streamTracks = stream.getAudioTracks();
  const streamTrack = streamTracks.length > 0 ? streamTracks[0] : undefined;

  const supportGetCapabilities =
    typeof InstallTrigger === "undefined" && !document.documentMode;

  const micData = streamTrack
    ? {
        streamTrack: {
          streamTrack: streamTrack,
          enabled: streamTrack.enabled,
          id: streamTrack.id,
          kind: streamTrack.kind,
          label: streamTrack.label,
          muted: streamTrack.muted,
          readyState: streamTrack.readyState,
          remote: streamTrack.remote,
        },
        settings: streamTrack.getSettings(),
        capabilities: supportGetCapabilities
          ? streamTrack.getCapabilities()
          : "The browser does not support `streamTrack.getCapabilities()`",
        constraints: streamTrack.getConstraints(),
      }
    : undefined;
  streamTrack.stop();
  return micData;
};

export const getBasicMicrophoneData = async () => {
  await requestMicrophonePermissions();
  const microphoneIds = await getAllMicsID();
  const microphoneDataPromises = microphoneIds.map((id) => async () => {
    const {
      streamTrack: { label },
    } = await getMicrophoneData(id);
    return {
      id,
      label,
    };
  });
  return resolvePromises(microphoneDataPromises);
};

export const getAllMicrophonesData = async (ids) => {
  await requestMicrophonePermissions();
  if (!ids) {
    ids = await getAllMicsID();
  }
  const microphonesDataPromises = ids.map((id) => async () => {
    const data = await getMicrophoneData(id);
    return data;
  });
  return resolvePromises(microphonesDataPromises);
};
